<template>
    <div class="container">
        <p class="contentBlack">本APP的虚拟货币充值服务由{{ this.company }}（以下简称“我方”）向您提供。</p>
        <p class="contentBlack">为了向您提供优质的服务，您应仔细阅读并同意《充值协议》(以下简称“本协议”)，请您务必审慎阅读、
            充分了解各条款内容，特别是关于免除或者限制责任、管辖与法律适用的条款，以及开通或使用某项服务的单独协议。除非您已阅读并接受本协议所有条款，
            否则您无权使用我方提供的服务。您一旦开始使用我方提供的金币服务，即视为您已阅读并同意本协议。</p>
        <p class="contentBlack">使用金币充值服务时，请务必保证您已满18岁，属于完全民事行为能力人，您未满18岁但依然继续充值或其他与您的民事行为能力相适应的行为，
            将视为已取得监护人或者法定代理人的同意。</p>

        <p class="contentBlack">一、[协议的范围]</p>
        <p class="content">
            1.1本协议是您与我方之间关于用户使用金币相关服务所订立的协议。“金币”是指{{ this.company }}及其相关服务可能存在的运营关联单位。
            “用户”是指使用金币服务的使用人，在本协议中更多地称为“您”。
        </p>
        <p class="content">
            1.2本协议项下的服务是我方向用户提供的服务（以下简称“本服务”）。
        </p>


        <p class="contentBlack">二、[“金币”购买规则及说明]</p>
        <p class="content">
            1.1“金币”是{{ this.company }}向您提供的用于相关消费的虚拟货币，您可以用“金币”在{{ this.name }}上购买虚拟道具、
            虚拟礼物赠予其他用户，也可使用“金币”购买网络互动交流服务等。
            “金币”的使用范围应以本平台认可范围内的商品或服务为准。为明确起见，您使用“金币”购买虚拟礼物
            赠予其他用户的行为，是一种及时生效的信息和娱乐的消费行为。本平台倡导理性消费，
            您应根据自己的实际需求理性购买相应数量的“金币”。虚拟礼物一经送出，
            该虚拟礼物的所有权和使用权立即自动归属收到虚拟礼物者所有。此外，
            除非国家法律法规或者本协议另有明确规定，否则您送出虚拟礼物后不得要求撤回、撤销、
            取消赠送，也不得要求收到礼物者或本平台退还该虚拟礼物、返还相应“金币”或退费。
            其他用户收到您送出的虚拟礼物后，可能根据适时有效的平台规则获得相应的虚拟权益。
            本平台有权根据平台运营情况等因素自行制定或调整虚拟权益的规则，您理解、尊重该等规则并不持有异议。
        </p>
        <p class="content">
            1.2人民币购买金币的比例以充值界面显示为准。您购买金币后的到账数量可能因为平台运营政策的
            变化而有所变化。具体到账数额以您购买金币相关渠道服务页面显示为准。
            公司有权根据运营情况随时变更上述兑换比例，并将在您购买金币相关渠道服务页面显示。
        </p>
        <p class="content">
            1.3您知晓并同意，金币一经购买成功，除法律法规明确规定外，
            在任何情况下不得以任何形式兑换为法定货币。如因您违反国家法律法规、
            违反本协议或其他与“{{ this.name }}”软件及相关服务相关的协议和规则，平台有权暂时或永久封禁您的账号，
            账号封禁后，您账户上的剩余金币或虛拟礼物/道具将被暂时冻结或全部扣除，
            同时不予返还您购买金币时的现金价值。
        </p>
        <p class="content">
            1.4您暂时只能通过手机APP与移动设备开发者认可的方式购买“金币”并支付相关服务费用。
        </p>
        <p class="content">
            1.5我方保留根据相关法律规定、主管部门要求、业务开展情况等因素对使用人民币
            购买“金币”的规则进行单方面变更、调整、中止或终止的权利。您同意无条件接受对上述购买规则的变更、
            调整、中止或终止，我方在平台开展前述行动时，将在平台公布或者以其他方式通知公示，
            并自公布之日起自动生效，而无需另行单独通知您，也不就该行动给您造成的任何损失承担任何责任。
        </p>

        <p class="contentBlack">三、[金币使用操作的不可逆]</p>
        <p class="content">
            您同意并认可金币使用操作的不可逆性，即当您使用金币进行聊天互动、音视频通话、购买虚拟道具、
            礼物或其他产品与服务的行为时，您知晓上述金币一经使用即视为消费完成。购买的虚拟道具、礼物仅可用于自用或赠送。
        </p>

        <p class="contentBlack">四、[使用本服务的方式]</p>
        <p class="content">
            您应当通过我方提供或认可的方式使用本服务。您依本协议条款所取得的权利不可转让，
            您不得使用未经我方授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。
        </p>

        <p class="contentBlack">五、[按现状提供服务]</p>
        <p class="content">
            您理解并同意，金币的服务是按照现有技术和条件所能达到的现状提供的。
            我方会尽最大努力向您提供服务，确保服务的连贯性和安全性。但我方不能随时预见和防范法律、
            技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、
            政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险，因为上述原因给您带来的不便，请谅解。
        </p>

        <p class="contentBlack">六、[用户违法行为]</p>
        <p class="content">
            1.您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于:
        </p>
        <p class="content">
            (1)发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、
            暴力以及任何违反国家法律法规的内容;
        </p>
        <p class="content">
            (2) 发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容;
        </p>
        <p class="content">
            (3)恶意虚构事实、隐瞒真相以误导、欺骗他人;
        </p>
        <p class="content">
            (4)发布、传送、传播广告信息及垃圾信息;
        </p>
        <p class="content">
            (5)其他法律法规禁止的行为。
        </p>
        <p class="content">
            2.您仔细阅读并同意，若因您的使用行为给相关用户或平台造成损害或损失，
            由此引起相关国家机关、机构对您提起诉讼、罚款或采取其他制裁措施，涉事国家机关、
            机构要求我方提供您使用我方服务的相关记录的，我方将按照法律规定处理。因您的使用行为引起的相关法律责任，
            应当由您承担，我方不承担任何责任。
        </p>
        <p class="content">
            3.如果我方发现或收到他人举报您发布的信息违反本条约定，我方有权依据法律规定、
            app使用协议、本协议、移动设备相关开发计划等独立判断并采取技术手段予以删除、
            屏蔽或断开链接。同时，我方有权视用户的行为性质，采取包括但不限于暂停或终止服务，
            限制、冻结或终止账号使用，扣除、减少收益、追究法律责任等措施。
        </p>
        <p class="content">
            4.您违反本条约定，导致任何第三方损害的，您应当独立承担责任；我方因此遭受损失的，您也应当一并赔偿。
        </p>
        

        <p class="contentBlack">七、[遵守当地法律监管]</p>
        <p class="content">
            1.您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。
            如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。
        </p>
        <p class="content">
            2.您应避免因使用本服务而使我方卷入政治和公共事件，否则我方有权暂停或终止对您的服务。
        </p>


        <p class="contentBlack">八、[用户发送、传播的内容与第三方投诉处理]</p>
        <p class="content">
            1.您通过本服务发送或传播的内容(包括但不限于网页、文字、图片、音频、视频、图表等)均由您自行承担责任。
        </p>
        <p class="content">
            2.您发送或传播的内容应有合法来源，相关内容为您所有或您已获得权利人的授权。
        </p>
        <p class="content">
            3.您同意我方可为履行本协议或提供本服务的目的而使用您发送或传播的内容。
        </p>
        <p class="content">
            4.如果我方收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，
            您同意我方有权进行独立判断并采取删除、屏蔽或断开链接等措施。
        </p>
        <p class="content">
            5.您使用本服务时不得违反国家法律法规、侵害他人合法权益。您理解并同意，
            如您被他人投诉侵权或您投诉他人侵权，我方有权将争议中相关方的主体、联系方式、
            投诉相关内容等必要信息提供给其他争议方或相关部门，以便及时解决投诉纠纷，保护他人合法权益。
        </p>


        <p class="contentBlack">九、[不可抗力及其他免责事由]</p>
        <p class="content">
            1.您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。
            不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，
            包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。
            出现上述情况时，我方将努力在第一时间与相关单位配合，及时进行修复，
            但是由此给您造成的损失我方在法律允许的范围内免责。
        </p>
        <p class="content">
            2.在法律允许的范围内，我方对以下情形导致的服务中断或受阻不承担责任:
        </p>
        <p class="content">
            (1)受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏;
        </p>
        <p class="content">
            (2)用户或我方的电脑、手机软件、系统、硬件和通信线路出现故障;
        </p>
        <p class="content">
            (3)用户因为自身原因操作不当、误看、误充值等等;
        </p>
        <p class="content">
            (4)用户通过非我方授权的方式使用本服务;
        </p>
        <p class="content">
            (5)其他我方无法控制或合理预见的情形;
        </p>
        <p class="content">
            (6)用户充值金币后，已在本平台作出例如聊天互动、音视频通话、赠予其他注册用户虚拟礼物等消费行为的，
            您理解并同意，本平台对于已消费的金币不提供退款服务。
        </p>
        <p class="content">
            因用户自身原因出现误看、误充值、理解错误等操作不当的行为的，我方不承担法律责任，且有权不予退款。
        </p>
        <p class="content">
            3.您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，
            我方不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。
            这些风险包括但不限于:
        </p>
        <p class="content">
            (1)来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息;
        </p>
        <p class="content">
            (2)因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、
            生理上的伤害以及经济上的损失;
        </p>
        <p class="content">
            (3)其他因网络信息或用户行为引起的风险。
        </p>
        <p class="content">
            4.您理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、
            交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、
            财产损失和环境破坏等，我方不承担法律责任。
        </p>
        <p class="content">
            5.我方依据本协议约定获得处理违法违规内容的权利，该权利不构成我方的义务或承诺，
            我方不能保证及时发现违法行为或进行相应处理。
        </p>
        <p class="content">
            6.在任何情况下，您不应轻信借款、索要密码、索取赠礼或其他涉及财产的网络信息。
            为保证您的财产安全，请勿轻信他人及添加他人第三平台联系方式。涉及财产操作的，
            请一定先核实对方身份，并请经常留意我方有关防范诈骗犯罪的提示。
        </p>
        <p class="content">
            7.您理解并同意:
        </p>
        <p class="content">
            (1) 如您发生退款行为，平台超出充值比例额外赠送的金币部分不在为您退款的行列，
            平台有权仅退款您实际支付部分的金额，用户无权对超出实际支付金额部分的金币数值提出退款需求，
            即若您充值了6元，假设根据充值活动实际到账金额为1000金币，若您就该笔交易产生退款，
            平台仅退还您实际支付的6元;
        </p>
        <p class="content">
            (2)如发生用户退款行为，平台有权追踪退款用户消费金额款项流动去向及消费对象，
            并有权向该用户消费对象追回其所有消费款项，包括平台额外赠送部分。
        </p>


        <p class="contentBlack">十、[协议的生效与变更]</p>
        <p class="content">
            1.您使用我方的服务即视为您已阅读本协议并接受本协议的约束。
        </p>
        <p class="content">
            2.我方有权在必要时修改本协议条款，您可以在相关服务页面查阅最新版本的协议条款。
        </p>
        <p class="content">
            3.本协议条款变更后，如果您继续使用我方提供的软件或服务，即视为您已接受修改后的协议。
            如果您不接受修改后的协议，应当停止使用我方提供的软件或服务。
        </p>

        <p class="contentBlack">十一、[服务的变更、 中断、终止]</p>
        <p class="content">
            1.我方可能会对服务内容进行变更，也可能会中断、中止或终止服务。
        </p>
        <p class="content">
            2.您理解并同意，我方有权自主决定经营策略。在我方发生合并、分立、收购、资产转让时，
            我方可向第三方转让本服务下相关资产；我方也可在单方通知您后，
            将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以我方通知的为准。
        </p>
        <p class="content">
            3.如发生下列任何一种情形，我方有权不经通知而中断或终止向您提供的服务:
        </p>
        <p class="content">
            (1)根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明;
        </p>
        <p class="content">
            (2)您违反相关法律法规或本协议的约定;
        </p>
        <p class="content">
            (3)按照法律规定或主管部门的要求;
        </p>
        <p class="content">
            (4)出于安全的原因或其他必要的情形。
        </p>
        <p class="content">
            4.您有责任自行备份存储在本服务中的数据。如果您的服务被终止，
            我方可以从服务器上永久地删除您的数据，但法律法规另有规定的除外。
            服务终止后，我方没有义务向您返还数据。
        </p>


        <p class="contentBlack">十二、[管辖与法律适用]</p>
        <p class="content">
            1.本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)。
        </p>
        <p class="content">
            2.本协议签订地为中华人民共和国湖南省长沙市。
        </p>
        <p class="content">
            3.若您和我方之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，
            您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
        </p>
        <p class="content">
            4.本协议所有条款的标题仅为阅读方便，不能作为本协议涵义解释的依据。
        </p>
        <p class="content">
            5.本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>


        <p class="contentBlack"></p>
        <p class="content"></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            gender: '',
            token: '',
            edition: '',

            name: '音缘',
            company: '长沙鼎韵网络科技有限公司'
        }
    },

    created() {
        document.title = '充值协议';
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
                this.checkName(p.edition);
            } catch(e) {}
        },

        checkName(edition) {
            this.name = '蜜觅';
            this.company = '长沙奕采信息科技有限公司';
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 14px;
    color: black;
    font-weight: 700;
}
</style>